/* AUTO-GENERATED. Do not edit by hand. */

/**
 * @remixicon/react v4.1.0 - Apache-2.0
 */
import type { RemixiconComponentType } from '../types'

/**
 * RiVimeoLine icon component from Remix Icon set.
 * 
 * @param props - RemixiconProps
 * @returns JSX element representing the RiVimeoLine icon
 */
const RiVimeoLine: RemixiconComponentType = (props): JSX.Element => {
  // Extract RemixiconProps
  const {
    color = 'currentColor',
    size = 24,
    ...rest
  } = props

  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      fill={color}
      width={size}
      height={size}
      {...rest}
    >
      <path fill="currentColor" d="M17.994 3.004C20.427 3.004 22 4.516 22 7.5c0 1.72-.998 3.94-1.832 5.235c-2.789 4.333-6.233 8.74-9.643 8.74c-3.706 0-4.67-6.831-5.092-8.432s-.533-2.21-1.17-3.233q-.475.33-1.33.93a.5.5 0 0 1-.693-.117L.926 8.807a.5.5 0 0 1 .027-.62Q5.193 3.278 8 3.278c2.392 0 3.125 2.816 3.324 4.223c.3 2.117.69 4.738 1.245 5.872c.556-.792 2.18-2.888 1.966-3.99c-.094-.487-1.317.183-1.887.078c-.425-.08-.805-.402-.805-1.026c0-1.31 1.851-5.43 6.15-5.43m.007 2c-2.194 0-3.251 1.533-3.653 2.208c1.25.046 1.97.818 2.134 1.803c.388 2.33-1.917 4.92-2.34 5.565c-.396.603-3.061 3.328-4.25-3.36a160 160 0 0 1-.665-4.186c-.17-1.151-.872-1.763-1.229-1.763c-.843 0-1.92.65-3.856 2.515c1.905-.115 2.545 2.276 2.917 3.633c.815 2.984 1.57 8.055 3.62 8.055c1.726 0 4.438-2.645 7.37-7.038c.208-.312 1.965-3.025 1.965-5.037c0-2.395-1.469-2.395-2.013-2.395"/>
    </svg>
  )
}

export default RiVimeoLine
